// src/auth/unauthorizedHandler.ts

let logoutHandler: (() => void) | null = null;

/**
 * Called from React (e.g. AuthProvider or a top-level screen)
 * to tell the system what "logout" means.
 */
export function setLogoutHandler(fn: (() => void) | null) {
    logoutHandler = fn;
}

/**
 * Called from Axios interceptor when we hit 401.
 */
export function notifyUnauthorized() {
    if (logoutHandler) {
        logoutHandler();
    }
}
